import React from "react";
import {Website} from "../layouts/Website";
import {PageTitle} from "../components/shared/PageTitle";
import {Box, Container, Typography} from "@mui/material";

export const InformazioniUtili = () => {
    return (
        <Website>
            <Container sx={{py: 5}}>
                <PageTitle title={'Informazioni Utili'} image={'icon-info'}/>
                {/*DOCUMENTI*/}
                <Box sx={{display:'flex', alignItems:'center', gap:'15px', mb:2}}>
                    <img src={require('../assets/icons/icon-doc.png')} alt={'icon day'} width={'35px'} />
                    <Typography variant={'h6'} color={'#d1112c'} fontWeight={'bold'} fontFamily={'Arial'}>
                        DOCUMENTI
                    </Typography>
                </Box>
                <Box sx={{display:'flex', alignItems:'center', gap:'15px', mb:4}}>
                    <Typography variant={'body'} color={'#000'} fontWeight={'normal'} fontFamily={'Arial'}>
                        È necessario un passaporto valido per il periodo di permanenza in Marocco. È inoltre indispensabile portare con sé i biglietti aerei stampati, sia del viaggio di andata sia del viaggio di ritorno, da presentare ai controlli in aeroporto.
                    </Typography>
                </Box>
                {/*CLIMA*/}
                <Box sx={{display:'flex', alignItems:'center', gap:'15px', mb:2}}>
                    <img src={require('../assets/icons/icon-clima.png')} alt={'icon day'} width={'35px'} />
                    <Typography variant={'h6'} color={'#d1112c'} fontWeight={'bold'} fontFamily={'Arial'}>
                        CLIMA
                    </Typography>
                </Box>
                <Box sx={{display:'flex', alignItems:'center', gap:'15px', mb:4}}>
                    <Typography variant={'body'} color={'#000'} fontWeight={'normal'} fontFamily={'Arial'}>
                        La stagione primaverile è il momento migliore per visitare Marrakech. Il clima è caratterizzato da giornate piacevolmente calde e serate fresche, con temperature diurne medie (20-25°C) e temperature notturne più basse (7-9°C) dato lo sbalzo termico. <br/>
                        Le precipitazioni sono limitate.
                    </Typography>
                </Box>
                {/*FUSO ORARIO*/}
                <Box sx={{display:'flex', alignItems:'center', gap:'15px', mb:2}}>
                    <img src={require('../assets/icons/icon-fuso.png')} alt={'icon day'} width={'35px'} />
                    <Typography variant={'h6'} color={'#d1112c'} fontWeight={'bold'} fontFamily={'Arial'}>
                        FUSO ORARIO
                    </Typography>
                </Box>
                <Box sx={{display:'flex', alignItems:'center', gap:'15px', mb:4}}>
                    <Typography variant={'body'} color={'#000'} fontWeight={'normal'} fontFamily={'Arial'}>
                        Marrakech si trova nel fuso orario UTC+1. <br/>
                        A marzo, durante il periodo di Ramandan, Marrakech è 1 ora indietro rispetto all'Italia.
                    </Typography>
                </Box>
                {/*TELEFONIA E INTERNET*/}
                <Box sx={{display:'flex', alignItems:'center', gap:'15px', mb:2}}>
                    <img src={require('../assets/icons/icon-internet.png')} alt={'icon day'} width={'35px'} />
                    <Typography variant={'h6'} color={'#d1112c'} fontWeight={'bold'} fontFamily={'Arial'}>
                        TELEFONIA E INTERNET
                    </Typography>
                </Box>
                <Box sx={{display:'flex', alignItems:'center', gap:'15px', mb:4}}>
                    <Typography variant={'body'} color={'#000'} fontWeight={'normal'} fontFamily={'Arial'}>
                        Marrakech ha una buona copertura Wi-Fi, con la maggior parte degli hotel, ristoranti e caffè che offrono connessione gratuita. <br/>
                        Per coloro che dispongono dicellulare aziendale, sarà attivata l’offerta Vodafone Red Top Mondo Corporate: 1000 minuti + 3GB di traffico (l’offerta sarà attiva per un mese, quindi non bisogna preoccuparsi di controllare giorni e orari - l’importante è monitorare le soglie con la dovuta attenzione).
                    </Typography>
                </Box>
                {/*PRESE DI CORRENTE*/}
                <Box sx={{display:'flex', alignItems:'center', gap:'15px', mb:2}}>
                    <img src={require('../assets/icons/icon-presa.png')} alt={'icon day'} width={'35px'} />
                    <Typography variant={'h6'} color={'#d1112c'} fontWeight={'bold'} fontFamily={'Arial'}>
                        PRESE DI CORRENTE
                    </Typography>
                </Box>
                <Box sx={{display:'flex', alignItems:'center', gap:'15px', mb:4}}>
                    <Typography variant={'body'} color={'#000'} fontWeight={'normal'} fontFamily={'Arial'}>
                        Le prese in Marocco sono di tipo C e E, compatibili con le spine italiane di tipo C (le classiche a due poli). <br/>
                        I classici alimentatori per iPhone e Android sono compatibili. Se si è in possesso di una presa a 3 poli o una schuko, consigliamo di portare con sè un adattatore.
                    </Typography>
                </Box>
                {/*COSA METTERE IN VALIGIA*/}
                <Box sx={{display:'flex', alignItems:'center', gap:'15px', mb:2}}>
                    <img src={require('../assets/icons/icon-valigia.png')} alt={'icon day'} width={'35px'} />
                    <Typography variant={'h6'} color={'#d1112c'} fontWeight={'bold'} fontFamily={'Arial'}>
                        COSA METTERE IN VALIGIA
                    </Typography>
                </Box>
                <Box sx={{display:'flex', alignItems:'center', gap:'15px', mb:4}}>
                    <Typography variant={'body'} color={'#000'} fontWeight={'normal'} fontFamily={'Arial'}>
                        Abiti leggeri e scarpe comode durante il giorno, utili per le escursioni, poiché Marrakech ha molte strade acciottolate e irregolari. Per la sera, non bisogna dimenticare di portare una giacca in quanto le temperature diminuiscono.
                    </Typography>
                </Box>
                {/*SALUTE*/}
                <Box sx={{display:'flex', alignItems:'center', gap:'15px', mb:2}}>
                    <img src={require('../assets/icons/icon-salute.png')} alt={'icon day'} width={'35px'} />
                    <Typography variant={'h6'} color={'#d1112c'} fontWeight={'bold'} fontFamily={'Arial'}>
                        SALUTE
                    </Typography>
                </Box>
                <Box sx={{display:'flex', alignItems:'center', gap:'15px', mb:4}}>
                    <Typography variant={'body'} color={'#000'} fontWeight={'normal'} fontFamily={'Arial'}>
                        Portare con sé farmaci di base (analgesici, antidolorifici, ecc.) e una prescrizione medica per eventuali medicinali di uso personale. Non sono richieste vaccinazioni obbligatorie.
                    </Typography>
                </Box>
                {/*SICUREZZA*/}
                <Box sx={{display:'flex', alignItems:'center', gap:'15px', mb:2}}>
                    <img src={require('../assets/icons/icon-sicurezza.png')} alt={'icon day'} width={'35px'} />
                    <Typography variant={'h6'} color={'#d1112c'} fontWeight={'bold'} fontFamily={'Arial'}>
                        SICUREZZA
                    </Typography>
                </Box>
                <Box sx={{display:'flex', alignItems:'center', gap:'15px', mb:4}}>
                    <Typography variant={'body'} color={'#000'} fontWeight={'normal'} fontFamily={'Arial'}>
                        Marrakech è generalmente sicura per i turisti, ma, come in ogni grande città, è importante prestare attenzione a borseggiatori, specialmente nei luoghi affollati come i souk e la piazza Jemaa el-Fna. <br/>
                        Tenere sempre sotto controllo i propri oggetti di valore e non portare con sè il passaporto originale, ma una fotocopia.
                    </Typography>
                </Box>
                {/*VALUTA*/}
                <Box sx={{display:'flex', alignItems:'center', gap:'15px', mb:2}}>
                    <img src={require('../assets/icons/icon-valuta.png')} alt={'icon day'} width={'35px'} />
                    <Typography variant={'h6'} color={'#d1112c'} fontWeight={'bold'} fontFamily={'Arial'}>
                        VALUTA
                    </Typography>
                </Box>
                <Box sx={{display:'flex', alignItems:'center', gap:'15px', mb:4}}>
                    <Typography variant={'body'} color={'#000'} fontWeight={'normal'} fontFamily={'Arial'}>
                        La moneta locale è il Dirham marocchino (MAD). 1 EURO equivale a 10,80 MAD (è opportuno controllare sempre il cambio prima di partire – <a href={'https://www.xe.com/'} target={'_blank'}>vedi qui</a>). <br/>
                        È possibile cambiare valuta in aeroporto, banche o case di cambio locali. <br/>
                        È consigliabile avere una carta prepagata con limite ridotto e una piccola somma in contanti per spese minori. <br/>
                        Le carte di credito sono accettate nei principali hotel e ristoranti. Sono disponibili numerosi sportelli automatici in città, ma bisogna fare attenzione a prelevare solo in orari diurni per motivi di sicurezza.
                    </Typography>
                </Box>
                {/*VARIE*/}
                <Box sx={{display:'flex', alignItems:'center', gap:'15px', mb:2}}>
                    <img src={require('../assets/icons/icon-varie.png')} alt={'icon day'} width={'35px'} />
                    <Typography variant={'h6'} color={'#d1112c'} fontWeight={'bold'} fontFamily={'Arial'}>
                        VARIE
                    </Typography>
                </Box>
                <Box sx={{display:'flex', alignItems:'center', gap:'15px', mb:4}}>
                    <Typography variant={'body'} color={'#000'} fontWeight={'normal'} fontFamily={'Arial'}>
                        La lingua ufficiale è l'arabo, ma il francese è ampiamente parlato e l’inglese è in crescita, specialmente nelle aree turistiche. Le mance non sono obbligatorie, ma sono molto apprezzate, specialmente per i camerieri, le guide turistiche e gli autisti di taxi.
                    </Typography>
                </Box>
            </Container>
        </Website>
    )
}
